import styled from 'styled-components';
import { getSizeBy, Heading1, Body2, Icon } from '@invent/wl-ui-kit';

export const PageErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const PageErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: ${getSizeBy(65)};
  max-width: ${getSizeBy(120)};
  padding: ${getSizeBy(5)};
`;

export const MainTitleError = styled(Heading1).attrs({ $shade: 'mediumEmphasis' })`
  margin-bottom: ${getSizeBy(3)};
  text-align: center;
`;

export const ExplainBody = styled(Body2).attrs({ $shade: 'mediumEmphasis' })`
  text-align: center;
`;

export const ActionsField = styled.div`
  display: grid;
  grid-gap: ${getSizeBy(3)} ${getSizeBy(4)};
  grid-template-columns: repeat(auto-fit, minmax(100px, 200px));
  justify-content: center;
  width: 100%;
  margin-top: ${getSizeBy(6)};
`;

export const ErrorIcon = styled(Icon)`
  margin-bottom: ${getSizeBy(3)};
  font-size: 72px;
`;
